"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationForWebpage = void 0;
var i18next_1 = __importDefault(require("i18next"));
var de = __importStar(require("../locales/de.json"));
var en = __importStar(require("../locales/en.json"));
var pt = __importStar(require("../locales/pt.json"));
var es = __importStar(require("../locales/es.json"));
var browserLang = navigator.language.slice(0, 2);
console.log('browser language', browserLang);
var supportedLangs = ['de', 'en', 'pt', 'es'];
var fallbackLang = 'de';
i18next_1.default.init({
    lng: supportedLangs.includes(browserLang) ? browserLang : fallbackLang,
    //fallbackLng: fallbackLang,  // this would translate stuff missing the translation file to that lang
    resources: {
        en: { translation: en },
        de: { translation: de },
        pt: { translation: pt },
        es: { translation: es },
    },
});
//TODO get language and currency codes based on the set language
i18next_1.default.transformCurrency = function (price, language, settings) {
    if (language === void 0) { language = 'de-DE'; }
    if (settings) {
        return new Intl.NumberFormat(language, settings).format(+price);
    }
    else {
        return new Intl.NumberFormat(language, {
            minimumFractionDigits: +price % 1 != 0 ? 2 : 0,
            maximumFractionDigits: 2,
        }).format(+price);
    }
};
/** Translate other parts of the website */
var processedElements = new WeakSet();
var processedTextNodes = new WeakSet();
function translateNode(el) {
    if (processedElements.has(el))
        return;
    if (el.closest('[data-i18n-ignore="true"], [translate="no"]')) {
        processedElements.add(el);
        return;
    }
    var key = el.getAttribute('data-i18n');
    if (key === null || key === void 0 ? void 0 : key.trim()) {
        try {
            el.textContent = i18next_1.default.t(key);
        }
        catch (err) {
            console.error('[i18n] translation error for key:', key, err);
        }
        processedElements.add(el);
        return;
    }
    if (el.childElementCount === 0) {
        Array.from(el.childNodes).forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
                var txt = node.textContent.trim();
                if (txt && !processedTextNodes.has(node)) {
                    try {
                        node.textContent = i18next_1.default.t(txt);
                    }
                    catch (err) {
                        console.error('[i18n] translation error for text:', txt, err);
                    }
                    processedTextNodes.add(node);
                }
            }
        });
        processedElements.add(el);
        return;
    }
    Array.from(el.children).forEach(function (child) { return translateNode(child); });
}
function safeIdle(cb, timeout) {
    if (timeout === void 0) { timeout = 1000; }
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function (deadline) {
            void deadline.timeRemaining();
            cb();
        }, { timeout: timeout });
    }
    else {
        setTimeout(cb, 0);
    }
}
var pending = [];
var timer = null;
function scheduleTranslate(nodes) {
    pending.push.apply(pending, nodes.filter(function (n) { return n.nodeType === 1; }));
    if (timer !== null)
        return;
    timer = window.setTimeout(function () {
        var batch = pending.splice(0);
        timer = null;
        if (batch.length > 500) {
            console.warn("[i18n] skipping large batch of ".concat(batch.length, " nodes"));
            return;
        }
        safeIdle(function () { return batch.forEach(translateNode); });
    }, 100);
}
/**
 * This observer is designed to translate any page element that is outside of our framework and therefore outside of our regular translate possibilities.
 */
exports.TranslationForWebpage = {
    observer: new MutationObserver(function (muts) {
        var added = [];
        muts.forEach(function (m) { return added.push.apply(added, Array.from(m.addedNodes)); });
        scheduleTranslate(added);
    }),
    translateNode: translateNode,
};
exports.default = i18next_1.default;
